


































































import { UserStaffParams } from '@/store/interfaces/staffUser';
import profile from '@/components/Staff/profile.vue';
import auth from '@/store/types/auth';
import unknowUser from '@/assets/images/unknow-user.png';
import userStaff from '@/store/types/userStaff';
import { TeipNotifications } from '@/util/teipNotifications';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'ProfileCurrentUser',
  components: {
    profile,
  },
  data: () => ({
    unknowUser,
  }),
  computed: {
    ...mapGetters({
      currenUser: `authModule/${auth.getters.GET_AUTH_USER}`,
    }),
  },
  methods: {
    ...mapActions({
      updateCurrentUser: `userStaff/${userStaff.actions.UPDATE_CURRENT_USER}`,
    }),
    async currentUser(newData: UserStaffParams): Promise<void> {
      const notification = new TeipNotifications();
      this.updateCurrentUser(newData).then(() => {
        notification.success('Actualizado correctamente');
      }).catch(() => {
        notification.warning('Algo salió mal :(');
      });
    },
  },
});

